module.exports = __webpack_public_path__ + "static/media/eye.ad9f2ea9.svg";